const DEFAULT_RECIPE_IMAGES = {
    appetizer: 'appetizer.jpg',
    appetizers: 'appetizer.jpg',
    snack: 'appetizer.jpg',
    snacks: 'appetizer.jpg',
    breakfast: 'breakfast.jpg',
    brunch: 'breakfast.jpg',
    dessert: 'dessert.jpg',
    dinner: 'dinner.jpg',
    supper: 'dinner.jpg',
    entree: 'dinner.jpg',
    lunch: 'lunch.jpg',
    salad: 'salad.jpg',
    salads: 'salad.jpg',
    side: 'side.jpg',
    sides: 'side.jpg',
    soup: 'soup.jpg',
    soups: 'soup.jpg',
    bread: 'side.jpg',
    drink: 'drink.jpg',
    drinks: 'drink.jpg',
    condiment: 'condiment.jpg',
    condiments: 'condiment.jpg'
};

/**
 * Derive a category-specific default image path for recipes that are missing photos.
 * Falls back to the dinner image when the category is unknown.
 */
export const getDefaultRecipeImage = (category) => {
    if (!category) {
        return '/images/dinner.jpg';
    }

    const key = category.trim().toLowerCase();
    const filename = DEFAULT_RECIPE_IMAGES[key] || 'dinner.jpg';
    return `/images/${filename}`;
};

export default getDefaultRecipeImage;
